import { ITncRepository } from '../../ports/ITncRepository';
import { TncCase } from '../../domain/entities';
import { EmployeeDecision } from '../enums';

export class RecordEmployeeDecisionUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(caseId: string, decision: EmployeeDecision, deadline?: string): Promise<TncCase> {
    return this.tncRepository.recordEmployeeDecision(caseId, decision, deadline);
  }
}
